/* eslint-disable @typescript-eslint/no-explicit-any */
// import { supabase } from '../lib/supabase';
// import { getSessionId } from './session';

// export const tracking = {
//   log: async (
//     type: 'UI' | 'METRIC' | 'INTERNAL' | 'ERROR',
//     name: string,
//     details: any = {}
//   ) => {
//     // Get the current logged-in user (if any)
//     const {
//       data: { user },
//     } = await supabase.auth.getUser();

//     return supabase.from('tracking_events').insert({
//       event_type: type,
//       event_name: name,
//       session_id: getSessionId(),
//       user_id: user?.id || null,
//       metadata: typeof details === 'string' ? { label: details } : details,
//       path: window.location.pathname, // Automatically track where they are
//     });
//   },
// };

/* eslint-disable @typescript-eslint/no-explicit-any */
// import { supabase } from '../lib/supabase';
// import { getSessionId } from './session';

const trackUmami = (name: string, data?: Record<string, any>) => {
  if (typeof window !== 'undefined' && (window as any).umami) {
    (window as any).umami.track(name, data);
  }
};

export const tracking = {
  log: async (
    _type: 'UI' | 'METRIC' | 'INTERNAL' | 'ERROR',
    name: string,
    details: any = {}
  ) => {
    const metadata = typeof details === 'string' ? { label: details } : details;

    trackUmami(name, metadata);
  },
};
